// ══════════════════════════════════════════════════════════════════════════════════════════════
//  ¿HAY ALGO A MEDIO ESCRIBIR EN ESTA PANTALLA?   (t530, B-2268, 28-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Cuando un paciente pasa al gabinete de este ordenador, su ficha se abre sola (components/PuestoGabinete). El dueño: si
//  en ese ordenador hay algo a medio escribir sin guardar, NO se le quita la pantalla: sale un aviso en la esquina. Esto
//  contesta «¿hay algo a medio escribir?» sin que cada formulario tenga que decirlo, y del lado PRUDENTE (ante la duda, sí:
//  un aviso de más cuesta un clic; un salto de más pierde lo escrito):
//   · lo que una pantalla marque a mano (`marcarSinGuardar(clave, true)` … `false` al guardar o salir);
//   · el campo en el que se está escribiendo AHORA (el que tiene el foco), si tiene texto;
//   · cualquier cuadro de texto, campo de una ventana o texto editable en el que se haya tecleado y siga en la pantalla con
//     texto: dentro de una ventana abierta, siempre; fuera, si se tecleó en los últimos 15 minutos (una nota guardada
//     hace un rato que se queda escrita en su sitio no frena la ficha para siempre).
//  Un buscador (type="search", role="search" o data-sin-borrador) no cuenta salvo que tenga el foco.
//
//  Sin React y sin nada de la app: lo carga la guardia (backend/services/paciente-en-gabinete.test.js) con un documento de
//  mentira. La ventana llega por parámetro.

const RECIENTE_MS = 15 * 60 * 1000
const TIPOS_TEXTO = new Set(['', 'text', 'email', 'tel', 'number', 'url', 'date', 'time', 'datetime-local'])

const _marcados = new Set()
const _escritos = new Map()   // elemento → cuándo se tecleó por última vez

export function marcarSinGuardar(clave, siono) {
  if (!clave) return
  if (siono) _marcados.add(String(clave)); else _marcados.delete(String(clave))
}

const etiqueta = (el) => String((el && el.tagName) || '').toLowerCase()
const atributo = (el, a) => { try { return el && typeof el.getAttribute === 'function' ? el.getAttribute(a) : null } catch (_) { return null } }
function dentro(el, selector) {
  try { return !!(el && typeof el.closest === 'function' && el.closest(selector)) } catch (_) { return false }
}

// ¿Es un sitio donde se escribe? (textarea, texto editable o un campo de texto)
export function esEscribible(el) {
  if (!el) return false
  if (el.disabled || el.readOnly) return false
  const tag = etiqueta(el)
  if (tag === 'textarea') return true
  if (el.isContentEditable === true || atributo(el, 'contenteditable') === 'true' || atributo(el, 'contenteditable') === '') return true
  if (tag === 'input') return TIPOS_TEXTO.has(String(atributo(el, 'type') || el.type || '').toLowerCase())
  return false
}
const esBuscador = (el) => String(atributo(el, 'type') || '').toLowerCase() === 'search' || atributo(el, 'data-sin-borrador') != null
  || dentro(el, '[role="search"]')
function tieneTexto(el) {
  try {
    if (etiqueta(el) === 'textarea' || etiqueta(el) === 'input') return String(el.value == null ? '' : el.value).trim() !== ''
    return String(el.textContent || '').trim() !== ''
  } catch (_) { return true }
}
const enUnaVentana = (el) => dentro(el, '.modal-safe') || dentro(el, '[role="dialog"]') || dentro(el, '[aria-modal="true"]')

// Lo que se teclea: se apunta el elemento (no lo escrito).
export function apuntarTecleo(el, ahora = Date.now()) {
  if (esEscribible(el)) _escritos.set(el, ahora)
}

// Lo engancha la pantalla una vez (components/PuestoGabinete). Devuelve cómo quitarlo.
export function vigilarLoQueSeEscribe(ventana) {
  const v = ventana || (typeof window !== 'undefined' ? window : null)
  const doc = v && v.document
  if (!doc || typeof doc.addEventListener !== 'function') return () => {}
  const f = (e) => apuntarTecleo(e && e.target)
  doc.addEventListener('input', f, true)
  return () => { try { doc.removeEventListener('input', f, true) } catch (_) { /* nada */ } }
}

export function hayAlgoSinGuardar(ventana, ahora = Date.now()) {
  if (_marcados.size) return true
  const v = ventana || (typeof window !== 'undefined' ? window : null)
  const doc = v && v.document
  try {
    const a = doc && doc.activeElement
    if (a && esEscribible(a) && tieneTexto(a)) return true
  } catch (_) { /* sin foco */ }
  for (const [el, cuando] of [..._escritos]) {
    if (!el || el.isConnected === false) { _escritos.delete(el); continue }
    if (esBuscador(el) || !tieneTexto(el)) continue
    if (enUnaVentana(el)) return true
    if (etiqueta(el) === 'input' && !dentro(el, 'form')) continue
    if (ahora - cuando < RECIENTE_MS) return true
  }
  return false
}

// Solo para las pruebas.
export function _olvidarTodo() { _marcados.clear(); _escritos.clear() }
